const fileTypes = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'csv',
  'txt',
  'rtf',
  'html',
  'zip',
  'mp3',
  'wma',
  'mpg',
  'flv',
  'avi',
  'jpg',
  'jpeg',
  'png',
  'gif',
  'pptx',
  'ppt',
  'heic',
  'webp',
];
export const fileUploadActions = [
  {
    name: 'fileUpload',
    label: 'File Upload',
    args: [
      {
        name: 'allowedFiles',
        label: 'Allowed File Type ',
        type: 'dropdown',
        value: '',
        multi: true,
        options: fileTypes,
      },
      {
        name: 'maxFiles',
        label: 'Max Allowed File',
        type: 'number',
        value: '',
        min: 1,
        max: 10,
      },
    ],
    // allowedTypes: ['number'],
  },
];
